import { EAppErrorKind } from '@/utils/error';
import { toAppError } from './appError';

/**
 * 重发有可能换来不同结果的错误。
 * 刻意用白名单:EAppErrorKind 有 19 个成员,新增的默认不重试才是安全侧。
 */
const RETRYABLE_KINDS: ReadonlySet<EAppErrorKind> = new Set([
  EAppErrorKind.NETWORK,
  EAppErrorKind.SERVER,
  EAppErrorKind.RATE_LIMITED,
  EAppErrorKind.LOCKED
]);

const DEFAULT_DELAY = 500;

/**
 * 重试预算。总耗时 =(count + 1)× 单次 timeout + 退避,
 * 因此声明 retry 必须同时声明 timeout —— 该约束由 TRequestConfig 在类型上强制。
 */
export interface IRetryOptions {
  /** 重试次数,不含首次 */
  count: number;
  /** 首次退避,之后逐次翻倍 */
  delay?: number;
}

const wait = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

/**
 * 次数用尽时抛最后一次的真实错误:NETWORK / SERVER 比「重试失败」更能说明原因。
 * 调用方的 signal 不必在此处理 —— 取消归一化成 CANCELED,它不在可重试集合里,循环即停。
 */
export const sendWithRetry = async <T>(send: () => Promise<T>, { count, delay = DEFAULT_DELAY }: IRetryOptions) => {
  let backoff = delay;

  for (let left = count; ; left--) {
    try {
      return await send();
    } catch (error) {
      if (left <= 0 || !RETRYABLE_KINDS.has(toAppError(error).kind)) throw error;
      await wait(backoff);
      backoff *= 2;
    }
  }
};
